import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
import { __rest as e } from "../_virtual/_tslib.js";
import { jsx as r, jsxs as t } from "react/jsx-runtime";
import { showError as o, HelperText as n, Label as i, ErrorText as a } from "@vds-core/form-elements";
import { Fonts as l, Body as s } from "@vds-core/typography";
import { calculateRem as d, withVDSManager as c, getOS as u, generateUUID as p } from "@vds-core/utilities";
import { AccessibilityTokens as h } from "@vds-tokens/accessibility";
import { ColorTokens as f } from "@vds-tokens/color";
import { FormControlsTokens as v } from "@vds-tokens/form-controls";
import { TypographyTokens as b } from "@vds-tokens/typography";
import { Component as m, Children as g, cloneElement as y } from "react";
import $ from "styled-components";
var k = r("svg", {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.6 21.6",
    children: r("path", {
      d: "M10.80213,19.80122a2.39567,2.39567,0,0,1-1.705-.707L2.50743,12.50444a2.41244,2.41244,0,0,1,0-3.40913L9.09808,2.50555a2.4159,2.4159,0,0,1,3.40908-.001l6.58967,6.59073a2.41244,2.41244,0,0,1,0,3.40913L12.50716,19.0942A2.394,2.394,0,0,1,10.80213,19.80122Zm-7.4998-9.911a1.289,1.289,0,0,0,0,1.81931L9.893,18.29929a1.31476,1.31476,0,0,0,1.81928,0l6.58967-6.58976a1.289,1.289,0,0,0,0-1.81931L11.71226,3.30047a1.29076,1.29076,0,0,0-1.81928,0ZM9.95,15.05h1.7V13.367H9.95Zm0-6.00953.561,2.635h.56952l.56951-2.635V6.55H9.95Z"
    })
  }),
  x = r("svg", {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.6 21.6",
    children: r("polygon", {
      points: "10.8 15.71 1.8 6.71 2.62 5.89 10.8 14.07 18.98 5.89 19.8 6.71 10.8 15.71"
    })
  });
function w(e, r, t, o, n) {
  return "dark" === e ? function (e, r, t, o) {
    var n;
    return n = t || e ? f.interactive.disabled.ondark.value : r && !o ? f.feedback.error.ondark.value : !r && o || r && o ? f.elements.primary.ondark.value : v.color.border.ondark.value, n;
  }(r, t, o, n) : function (e, r, t, o) {
    var n;
    return n = t || e ? f.interactive.disabled.onlight.value : r && !o ? f.feedback.error.onlight.value : !r && o || r && o ? f.elements.primary.onlight.value : v.color.border.onlight.value, n;
  }(r, t, o, n);
}
function C(e, r) {
  var t;
  return t = "dark" === r && e ? f.interactive.disabled.ondark.value : "dark" !== r && e ? f.interactive.disabled.onlight.value : "dark" !== r || e ? f.elements.primary.onlight.value : f.elements.primary.ondark.value, t;
}
function S(e) {
  return e ? "102px" : "66px";
}
var _ = $.div.withConfig({
    displayName: "SelectContainer",
    componentId: "VDS__sc-tcrs1y-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  box-sizing: border-box;\n  height: ", ";\n  width: 100%;\n  vertical-align: top;\n  margin: 0;\n  background-color: ", ";\n  border-radius: ", ";\n  border-color: ", ";\n  border-width: ", ";\n  border-style: solid;\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), d(44), function (_ref) {
    var e = _ref.surface,
      r = _ref.$error,
      t = _ref.$transparentBackground;
    return t && !r ? "transparent" : function (e, r) {
      var t;
      return t = "dark" !== r || e ? e && "dark" !== r ? f.feedback.error.background.onlight.value : e && "dark" === r ? f.feedback.error.background.ondark.value : v.color.background.onlight.value : v.color.background.ondark.value, t;
    }(r, e);
  }, v.border.radius.value, function (_ref2) {
    var e = _ref2.surface,
      r = _ref2.readOnly,
      t = _ref2.$error,
      o = _ref2.disabled,
      n = _ref2.$focused;
    return w(e, r, t, o, n);
  }, d(v.border.width.value), function (_ref3) {
    var e = _ref3.disabled,
      r = _ref3.readOnly,
      t = _ref3.surface;
    return e && "dark" === t && !r && "color: ".concat("dark" === t ? f.interactive.disabled.ondark.value : f.interactive.disabled.onlight.value, ";\n  ");
  }, function (_ref4) {
    var e = _ref4.surface,
      r = _ref4.disabled,
      t = _ref4.readOnly;
    return !r && !t && "\n    &:hover {\n      outline: none;\n      border-color: ".concat("dark" === e ? v.color.border.hover.ondark.value : v.color.border.hover.onlight.value, ";\n    }\n  ");
  }, function (_ref5) {
    var e = _ref5.keyboardFocused,
      r = _ref5.readOnly,
      t = _ref5.disabled,
      o = _ref5.surface,
      n = _ref5.$hovered;
    return e && !n && !r && !t && " \n      &::before {\n        border: ".concat(d(h.focusring.borderwidth.value), " dashed ").concat("dark" === o ? h.color.focusring.ondark.value : h.color.focusring.onlight.value, ";\n        border-radius: 6px;\n        content: '';\n        left: 50%; \n        position: absolute;\n        top: 50%;\n        pointer-events: none;\n        transform: translate(-50%, -50%);\n        width: calc(100% + ").concat(d(2 * parseInt(h.focusring.space.offset.value, 10) + 2), ");\n        height: calc(100% + ").concat(d(2 * parseInt(h.focusring.space.offset.value, 10) + 2), ");\n      } \n    ");
  }),
  T = $.select.withConfig({
    displayName: "SelectEl",
    componentId: "VDS__sc-tcrs1y-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border: none;\n  background: transparent;\n  width: 100%;\n  min-width: ", ";\n  display: inline-flex;\n  -moz-appearance: none;\n  appearance: none;\n  &::-ms-expand {\n    display: none;\n  }\n  outline: none;\n  pointer-events: auto;\n  color: ", ";\n  opacity: 1;\n  line-height: ", ";\n  font-size: ", ";\n  letter-spacing: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  padding: ", ";\n  ", "\n  option {\n    background-color: ", ";\n  }\n"])), function (_ref6) {
    var e = _ref6.$inlineLabel;
    return S(e);
  }, function (_ref7) {
    var e = _ref7.disabled,
      r = _ref7.readOnly,
      t = _ref7.surface;
    return "dark" !== t || e ? e && !r && "dark" !== t ? f.interactive.disabled.onlight.value : "dark" === t && e ? f.interactive.disabled.ondark.value : f.elements.primary.onlight.value : f.elements.primary.ondark.value;
  }, d(b.lineheight.body[20].value), d(b.fontsize.body[16].value), d(b.letterspacing.wide.value), l.VerizonNHGeDS, b.fontweight.regular.value, function (_ref8) {
    var e = _ref8.$inlineLabel;
    return e ? d(v.space.inset.value, 44, v.space.inset.value, 0) : d(v.space.inset.value, 43, v.space.inset.value, v.space.inset.value);
  }, function (_ref9) {
    var e = _ref9.readOnly;
    return e && "pointer-events: none;";
  }, function (_ref0) {
    var e = _ref0.surface;
    return "dark" === e ? f.background.primary.dark.value : f.background.primary.light.value;
  }),
  L = $.div.withConfig({
    displayName: "ComponentContainer",
    componentId: "VDS__sc-tcrs1y-2"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  width: ", ";\n  min-width: ", ";\n"])), function (_ref1) {
    var e = _ref1.$helperTextPlacement;
    return "right" === e ? "row" : "column";
  }, function (_ref10) {
    var e = _ref10.width;
    return e;
  }, function (_ref11) {
    var e = _ref11.$inlineLabel;
    return S(e);
  }),
  I = $.div.withConfig({
    displayName: "StyledContainer",
    componentId: "VDS__sc-tcrs1y-3"
  })(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  width: ", ";\n  position: relative;\n  width: ", ";\n  input[type='number'] {\n    -moz-appearance: textfield; /* Firefox */\n  }\n"])), function (_ref12) {
    var e = _ref12.$helperText,
      r = _ref12.$helperTextPlacement;
    return e && "right" === r ? "50%" : "100%";
  }, function (_ref13) {
    var e = _ref13.width;
    return e;
  }),
  D = $.span.withConfig({
    displayName: "IconContainer",
    componentId: "VDS__sc-tcrs1y-4"
  })(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 1;\n  margin-left: ", ";\n  right: ", ";\n  top: 50%;\n  transform: translateY(-50%);\n  height: 1.25rem;\n  pointer-events: none;\n  ", ";\n"])), d(12), d(12), function (_ref14) {
    var e = _ref14.disabled,
      r = _ref14.surface;
    return e && "\n    color: ".concat("dark" === r ? f.elements.primary.ondark.value : f.palette.gray85.value, ";\n    border-color: ").concat(f.palette.gray85.value, ";\n  ");
  }),
  E = $.label.withConfig({
    displayName: "InlineLabel",
    componentId: "VDS__sc-tcrs1y-5"
  })(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  padding: ", ";\n  &:focus {\n    outline: none;\n  }\n"])), d(v.space.inset.value, 4, v.space.inset.value, v.space.inset.value)),
  V = $.span.withConfig({
    displayName: "FlexedRowContainer",
    componentId: "VDS__sc-tcrs1y-6"
  })(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: row;\n  position: relative;\n"]))),
  F = $.span.withConfig({
    displayName: "FlexedColContainer",
    componentId: "VDS__sc-tcrs1y-7"
  })(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  position: relative;\n  width: ", ";\n"])), function (_ref15) {
    var e = _ref15.$helperText,
      r = _ref15.$helperTextPlacement;
    return e && "right" === r ? "50%" : "100%";
  }),
  B = $.div.withConfig({
    displayName: "IconSVGWrapper",
    componentId: "VDS__sc-tcrs1y-8"
  })(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n  min-height: ", ";\n  min-width: ", ";\n  ", ";\n  &:active,\n  &:focus {\n    outline: none;\n  }\n  svg {\n    path,\n    polygon {\n      fill: ", ";\n    }\n  }\n"])), function (_ref16) {
    var e = _ref16.$iconSize;
    return d(e);
  }, function (_ref17) {
    var e = _ref17.$iconSize;
    return d(e);
  }, function (_ref18) {
    var e = _ref18.$iconSize;
    return d(e);
  }, function (_ref19) {
    var e = _ref19.$iconSize;
    return d(e);
  }, function (_ref20) {
    var e = _ref20.tabIndex;
    return e && e < 0 && "\n    outline: none;\n    pointer-events: none;\n  ";
  }, function (_ref21) {
    var e = _ref21.$iconColor;
    return e;
  });
var O = /*#__PURE__*/function (_m) {
  _inherits(O, _m);
  function O(e) {
    var _this;
    _classCallCheck(this, O);
    var t;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(O).call(this, e)), t = _assertThisInitialized(_assertThisInitialized(_this)), _this._onBlur = function (e) {
      t.state.keyboardFocused && t.setState({
        keyboardFocused: !1
      }), !e.target.value && void 0 === t.props.error && t.props.required && t.setState({
        emptyError: !0
      }), t.setState({
        focused: !1
      }), "blur" !== t.props.errorEvent && "blurAndChange" !== t.props.errorEvent || o(e, t);
    }, _this._onChange = function (e) {
      var r, n;
      null === (n = null === (r = t.props) || void 0 === r ? void 0 : r.onChange) || void 0 === n || n.call(r, e), t.isAndroidDevice && e.target.focus(), t.setState({
        selectedValue: e.target.value
      }), void 0 === t.props.error && t.props.required && e.target.value && t.setState({
        emptyError: !1
      }), "change" !== t.props.errorEvent && "blurAndChange" !== t.props.errorEvent || o(e, t);
    }, _this.setHover = function () {
      t.setState({
        hovered: !0
      });
    }, _this.unSetHover = function () {
      t.setState({
        hovered: !1
      });
    }, _this._onFocus = function () {
      var e = t.props.readOnly;
      e || (t.setState({
        focused: !0
      }), t.state.hovered || t.state.keyboardFocused || t.setState({
        keyboardFocused: !0
      }));
    }, _this._onMouseDown = function () {
      t.state.keyboardFocused && t.setState({
        keyboardFocused: !1
      });
    }, _this.renderIcon = function () {
      var _t$props = t.props,
        e = _t$props.disabled,
        o = _t$props.surface,
        n = _t$props.error,
        i = _t$props.readOnly,
        a = t.state.emptyError || t.state.error || "boolean" == typeof n && n;
      return r(D, {
        tabIndex: -1,
        disabled: e,
        surface: o,
        "aria-hidden": !0,
        children: !i && r(B, {
          tabIndex: -1,
          $iconSize: 20,
          $iconColor: C(e, o),
          "aria-hidden": !0,
          "aria-label": "" + (a && !t.state.focused ? "error icon" : "caret-down icon"),
          children: a && !t.state.focused ? k : x
        })
      });
    }, _this._renderChildren = function (e) {
      var r = t.props.children;
      if (!r) return null;
      var o = "android" === u();
      if (r && Array.isArray(r)) {
        var _n = r[0] ? r[0].props && r[0].props.disabled : r.props && r.props.disabled,
          _i = _n ? r.length - 1 : r.length;
        return g.map(r, function (r, a) {
          var l = 0 === a && _n ? "".concat(r.props.children) : "".concat(r.props.children === t.state.selectedValue ? "selected" : "", " ").concat(r.props.children, " item ").concat(a + (_n ? 0 : 1), " of ").concat(_i > 1 ? _i : 1);
          return y(r, {
            "aria-label": o ? "".concat(e, " ").concat(l) : l,
            onMouseEnter: t.setHover,
            onMouseLeave: t.unSetHover,
            role: o ? void 0 : "option"
          });
        });
      }
      return y(r, {
        onMouseEnter: t.setHover,
        onMouseLeave: t.unSetHover,
        role: o ? void 0 : "option"
      });
    }, _this._renderHelperText = function () {
      var _t$props2 = t.props,
        e = _t$props2.helperText,
        o = _t$props2.helperTextPlacement,
        i = _t$props2.disabled,
        a = _t$props2.surface;
      return r(n, {
        helperText: e,
        helperTextPlacement: o,
        disabled: i,
        surface: a
      });
    }, _this.state = {
      focused: !1,
      hovered: !1,
      selectedValue: void 0,
      emptyError: !1,
      error: "function" != typeof _this.props.error && _this.props.error
    };
    return _this;
  }
  _createClass(O, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var e = this;
      var r = this.props.children;
      this.isAndroidDevice = "android" === u(), r && Array.isArray(r) && r.length > 1 ? (r.forEach(function (r) {
        r && r.props && r.props.children && r.props.selected && e.setState({
          selectedValue: r.props.children
        });
      }), !this.state.selectedValue && r[0] && r[0].props && r[0].props.children && this.setState({
        selectedValue: r[0].props.children
      })) : r && r.props && r.props.children && this.setState({
        selectedValue: r.props.children
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(e) {
      var _this$props = this.props,
        r = _this$props.error,
        t = _this$props.required;
      "boolean" == typeof r && e.error !== r && this.setState({
        error: r
      }), void 0 === r && e.required !== t && this.setState({
        emptyError: !1
      });
    }
  }, {
    key: "render",
    value: function render() {
      var o = this.props,
        n = o.surface,
        l = o.error,
        c = o.readOnly,
        u = o.label,
        h = o.errorText,
        v = o.width,
        b = o.id,
        m = o.inlineLabel,
        g = o.tooltip,
        y = o.tooltipContent,
        $ = o.tooltipTitle,
        k = o.tooltipCloseButtonText,
        x = o.helperText,
        w = o.helperTextPlacement,
        S = o.ariaLabel,
        D = o.selectId,
        B = o.transparentBackground,
        H = o.errorEvent,
        z = o.selectRef,
        M = e(o, ["surface", "error", "readOnly", "label", "errorText", "width", "id", "inlineLabel", "tooltip", "tooltipContent", "tooltipTitle", "tooltipCloseButtonText", "helperText", "helperTextPlacement", "ariaLabel", "selectId", "transparentBackground", "errorEvent", "selectRef"]),
        P = this.state.emptyError || this.state.error || "boolean" == typeof l && l,
        q = D || p(),
        A = u || "",
        N = void 0 === l && this.state.emptyError ? "You must enter a ".concat(A) : h,
        Z = S || (this.props.required ? "".concat(A, " required") : "".concat(A, " Optional"));
      function j() {
        return P && N ? x ? "".concat(Z, " ").concat(N, " ").concat(x) : "".concat(Z, " ").concat(N) : x ? "".concat(Z, " ").concat(x) : Z;
      }
      return r(L, {
        width: v,
        $inlineLabel: m,
        $helperTextPlacement: w,
        onMouseDown: this._onMouseDown,
        children: t(I, {
          id: b,
          $helperTextPlacement: w,
          $helperText: x,
          children: [u && !m && r(i, {
            disabled: this.props.disabled,
            surface: n,
            required: this.props.required,
            label: u,
            tooltip: g,
            tooltipTitle: $,
            tooltipContent: y,
            tooltipCloseButtonText: k,
            "data-testid": "test-label",
            id: q,
            "aria-label": u,
            htmlFor: q,
            labelMarginBottom: d(4),
            helperTextPlacement: w,
            helperText: x,
            calculateLabelColor: C
          }), t(V, {
            children: [t(F, {
              $helperText: x,
              $helperTextPlacement: w,
              children: [t(_, {
                $transparentBackground: B,
                disabled: this.props.disabled,
                surface: n,
                readOnly: c,
                $error: P,
                width: v,
                onMouseEnter: this.setHover,
                onMouseLeave: this.unSetHover,
                $hovered: this.state.hovered,
                $focused: this.state.focused,
                keyboardFocused: this.state.keyboardFocused,
                onFocus: this._onFocus,
                children: [m && u && r(E, {
                  tabIndex: -1,
                  htmlFor: q,
                  children: r(s, {
                    size: "large",
                    bold: !0,
                    color: this.props.disabled && "dark" !== n ? f.interactive.disabled.onlight.value : "dark" !== n || this.props.disabled ? "dark" === n && this.props.disabled ? f.interactive.disabled.ondark.value : f.elements.primary.onlight.value : f.elements.primary.ondark.value,
                    children: u
                  })
                }), r(T, Object.assign({}, M, {
                  ref: z,
                  $errorEvent: H,
                  required: this.props.required,
                  "aria-label": this.isAndroidDevice ? void 0 : j(),
                  disabled: this.props.disabled,
                  readOnly: c,
                  surface: n,
                  id: q,
                  tabIndex: 0,
                  autoComplete: this.props.autoComplete,
                  onKeyDown: O._onKeyDown,
                  onBlur: this._onBlur,
                  onChange: this._onChange,
                  $inlineLabel: m,
                  keyboardFocused: this.state.keyboardFocused,
                  children: this._renderChildren(j())
                })), this.renderIcon()]
              }), P && N && !this.props.disabled && !c && r(a, {
                errorLabelSpacing: d(8),
                errorText: N,
                surface: n,
                error: P
              })]
            }), x && "right" === w && this._renderHelperText()]
          }), x && "bottom" === w && this._renderHelperText()]
        })
      });
    }
  }]);
  return O;
}(m);
O._onKeyDown = function (e) {
  var r = e.type;
  "click" !== r && e.target.focus();
}, O.defaultProps = {
  transparentBackground: !1,
  surface: "light",
  error: void 0,
  errorEvent: "blur",
  readOnly: !1,
  width: "100%",
  label: "",
  tooltipCloseButtonText: "Close",
  autoComplete: "off",
  helperTextPlacement: "bottom",
  inlineLabel: !1
};
var H = c(O);
export { H as default };